@charset "UTF-8";

/* src/app/modules/display/components/menus/marketing-menu/building-blocks/menu-cards/embedded-image-card/embedded-image-card.component.scss */
.f12px {
  font-size: 0.75rem;
}
.f14px {
  font-size: 0.875rem;
}
.f16px {
  font-size: 1rem;
}
.f18px {
  font-size: 1.125rem;
}
.f20px {
  font-size: 1.25rem;
}
.f24px {
  font-size: 1.5rem;
}
.f32px {
  font-size: 2rem;
}
.f48px {
  font-size: 3rem;
}
.f64px {
  font-size: 4rem;
}
.embedded-image-card-container {
  position: relative;
  width: 100%;
  height: 100%;
  line-height: 1;
}
.embedded-image-card-container .top-row {
  position: relative;
  z-index: 1;
  top: 0;
  left: 0;
  right: 0;
}
.embedded-image-card-container .embedded-image {
  position: relative;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}
.embedded-image-card-container .product-info {
  position: relative;
  z-index: 11;
  bottom: 0;
  width: 100%;
}
.embedded-image-card-container .marketing-card-product-name {
  font-size: 1.5rem;
  line-height: 1.75rem;
  font-family: poppins, sans-serif;
  font-weight: 700;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow-x: clip;
  min-width: 0;
}
.embedded-image-card-container .embedded-card-badge-asset {
  display: block;
  margin-left: 0.5rem;
}
.embedded-image-card-container .embedded-card-image-asset {
  height: 100%;
  width: 100%;
}
.embedded-image-card-container .marketing-card-product-brand {
  font-size: 1rem;
  font-family: poppins, sans-serif;
  font-weight: 600;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow-x: clip;
  min-width: 0;
}
.embedded-image-card-container .marketing-card-product-thc {
  font-size: 1rem;
  font-family: poppins, sans-serif;
  font-weight: 600;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow-x: clip;
  min-width: 0;
}
.embedded-image-card-container .marketing-card-product-cbd {
  font-size: 1rem;
  font-family: poppins, sans-serif;
  font-weight: 600;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow-x: clip;
  min-width: 0;
}
.embedded-image-card-container .marketing-card-product-size {
  font-size: 1rem;
  font-family: poppins, sans-serif;
  font-weight: 600;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow-x: clip;
  min-width: 0;
}
.embedded-image-card-container .marketing-card-product-price {
  font-size: 1rem;
  font-family: poppins, sans-serif;
  font-weight: 600;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow-x: clip;
  min-width: 0;
}
.embedded-image-card-container .embed-image-card {
  color: #ffffff;
}
.embedded-image-card-container .embed-image-card .marketing-card-product-thc {
  font-size: 1rem;
  font-family: poppins, sans-serif;
  font-weight: 600;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow-x: clip;
  min-width: 0;
}
.embedded-image-card-container .embed-image-card .marketing-card-product-cbd {
  font-size: 1rem;
  font-family: poppins, sans-serif;
  font-weight: 600;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow-x: clip;
  min-width: 0;
}
.embedded-image-card-container .embed-image-card .marketing-card-product-size {
  font-size: 1rem;
  font-family: poppins, sans-serif;
  font-weight: 600;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow-x: clip;
  min-width: 0;
}
.embedded-image-card-container .embed-image-card .name-desc {
  max-height: 100%;
}
.embedded-image-card-container .embed-image-card .name-desc .marketing-card-product-desc {
  font-family: poppins, sans-serif;
  font-weight: 400;
  margin-top: 2%;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  line-height: 1.25;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}
.embedded-image-card-container .product-label {
  z-index: 12;
  position: relative;
  transform: translate(0, 50%);
}
.embedded-image-card-container .label-container {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
}
/*# sourceMappingURL=embedded-image-card.component.css.map */
